module.exports = __webpack_public_path__ + "media/images/sandbox/rondell/rondell-2-1d843db45548ae4cbde845343e4b197b.jpg";